export type SmartAppBannerLayoutType = 'public' | 'personalArea' | 'anonymousArea';

export const isMobileAppPath = (pathname: string) => /^\/mobile-app\/?$/.test(pathname);

export const shouldShowSmartAppBanner = ({
    isXs,
    pathname,
    layoutType,
    isWebview,
    isDismissed,
    isAutotest,
}: {
    isXs: boolean;
    pathname: string;
    layoutType: SmartAppBannerLayoutType;
    isWebview: boolean;
    isDismissed: boolean;
    isAutotest: boolean;
}) => {
    return isXs && layoutType === 'public' && !isWebview && !isDismissed && !isAutotest && !isMobileAppPath(pathname);
};
